import React from 'react'
import { Box, Grid } from '@mui/material'
import PaymentHistory from 'components/payments/PaymentHistory'
import PaymentActions from 'components/payments/PaymentActions/PaymentActions'
import PaymentSummary from '../../components/payments/PaymentSummary'

const Payments = () => {
  return (
    <>
      <Grid container spacing={2} sx={{ flex: 1, height: '100%' }}>
        <Grid item xs={12} sm={4} md={3} lg={3}>
          <PaymentSummary />
        </Grid>
        <Grid item xs={12} sm={8} md={9} lg={9}>
          <Box mb={2}>
            <PaymentActions />
          </Box>
          <PaymentHistory />
        </Grid>
      </Grid>
    </>
  )
}

export default Payments
